import React from 'react';
import { Button, Box, Typography } from '@mui/material';

const SystemStatusBar = ({ isActive, onToggle }) => {
	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				bgcolor: 'background.paper',
				borderRadius: 1,
				p: 2,
				mb: 3,
			}}
		>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
				<Box
					sx={{
						height: 12,
						width: 12,
						borderRadius: '50%',
						bgcolor: isActive ? 'success.main' : 'grey.400',
						animation: isActive ? 'pulse 2s infinite' : 'none',
						'@keyframes pulse': {
							'0%': { opacity: 1 },
							'50%': { opacity: 0.5 },
							'100%': { opacity: 1 },
						},
					}}
				/>
				<Typography sx={{ fontWeight: 500 }}>
					System Status:{' '}
					<Typography
						component="span"
						sx={{
							color: isActive ? 'success.main' : 'text.secondary',
							fontWeight: 500,
							marginRight: '25px',
						}}
					>
						{isActive ? 'Active' : 'Inactive'}
					</Typography>
				</Typography>
			</Box>

			<Button
				onClick={onToggle}
				variant="contained"
				sx={{
					bgcolor: isActive ? 'error.main' : 'success.main',
					'&:hover': {
						bgcolor: isActive ? 'error.dark' : 'success.dark',
					},
					px: 3,
				}}
			>
				{isActive ? 'Stop System' : 'Start System'}
			</Button>
		</Box>
	);
};

export default SystemStatusBar;
